import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from 'reactstrap';
import $ from 'jquery';
import SettingsPage from '../../views/SettingsPage/';
const GLOBAL = require('../../Globals');

class InstitutionView extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			name : '',
			addr : '',
			email : '',
			phone : '',
			mobile : '',
			fax : '',
			person : '',
			country : '',
			state : 'TamilNadu',
			currency : '',
			language : '',
			insCode : '',
			timeZone : '',
			logo : '',
			url :'',
			_message : '',
			value : '',
			alertClass :'',
			posts : [],
			data : [],
		}
		this.onChange = this.onChange.bind(this);
		this.onBack = this.onBack.bind(this);
	}
	
	/** redirect to Edit institution **/
	onBack(e){
		
		this.setState({_redirect :true});
	}
	
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	/** get institution details **/
	getdetails(){
	   $("#showLoader").show();
		GetData('institution/getinstitution').then((result) => {
			 $("#showLoader").hide();
			let res = result;
			if(res){
				this.setState({
					name : res[0]['name'],
					addr : res[0]['address'],
					email : res[0]['email'],
					phone : res[0]['phone'],
					mobile : res[0]['mobile'],
					fax : res[0]['fax'],
					person : res[0]['contactperson'],
					country : res[0]['countryname'],
					currency : res[0]['currency'],
					language : res[0]['language'],
					inscode : res[0]['code'],
					timezone : res[0]['timezone'],
					url : res[0]['url']
				});
			}
		});
	}
	
	/** This function wiil be call when page loading **/
	componentWillMount(){
		
		this.getcountry();
		this.getdetails();
	}
	
	/** get country **/
	getcountry(){
		GetData('home/getcountry').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}

	getBase64(file) {
	   var reader = new FileReader();
	   reader.readAsDataURL(file);
	   reader.onload = function () {
		 console.log(reader.result);
	   };
	   reader.onerror = function (error) {
		 console.log('Error: ', error);
	   };
	}
	
  render() {
	  
	var items = this.state.posts;
	
	if(this.state._redirect){
		  
		return (<Redirect to='/settings/editinstitution'/>);
	}
		
	return (
		<div>
		  <SettingsPage />
			<div className="animated fadeIn">
				<Row>
				  <Col md="12">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<Card>
						<CardHeader>
							<strong>Institution Details</strong>
							<span className="pull-right">
								<Button outline color="primary" onClick={this.onBack}>Edit</Button>
							</span>
						</CardHeader>
						<CardBody>
						  <Row>
							<Col md="9">
							<Card>
							 <CardBody>
							 <Row>
								<Col md="6">
								 <Row>
								  <Col md="5">
									<FormGroup>
									  <b>Institution Name</b>
									</FormGroup>
								  </Col>
								  <Col md="7">
									<span>: {this.state.name}</span>
								  </Col>
								 </Row>
								</Col>
								<Col md="6">
								 <Row>
								  <Col md="5">
									<FormGroup>
									  <b>Institution Address</b>
									</FormGroup>
								  </Col>
								  <Col md="7">
									<span>: {this.state.addr}</span>
								  </Col>
								 </Row>
								</Col>
								<Col md="6">
								 <Row>
								  <Col md="5">
									<FormGroup>
									  <b>Institution Email</b>
									</FormGroup>
								   </Col>
								  <Col md="7">
									<FormGroup>
									<span>: {this.state.email}</span>
									</FormGroup>
								  </Col>
								 </Row>
								</Col>
								<Col md="6">
								 <Row>
								  <Col md="5">
									<FormGroup>
									  <b>Institution Phone</b>
									</FormGroup>
								  </Col>
								  <Col md="7">
									<span>: {this.state.phone}</span>
								  </Col>
								 </Row>
								</Col>
								<Col md="6">
								 <Row>
								  <Col md="5">
									<FormGroup>
									  <b>Institution Mobile</b>
									</FormGroup>
								  </Col>
								  <Col md="7">
									<span>: {this.state.mobile}</span>
								  </Col>
								 </Row>
								</Col>
								<Col md="6">
								 <Row>
								  <Col md="5">
									<FormGroup>
									  <b>Institution Fax</b>
									</FormGroup>
								  </Col>
								  <Col md="7">
									<span>: {this.state.fax}</span>
								  </Col>
								 </Row>
								</Col>
								<Col md="6">
								 <Row>
								  <Col md="5">
									<FormGroup>
									  <b>Contact Person</b>
									</FormGroup>
								  </Col>
								  <Col md="7">
									<span>: {this.state.person}</span>
								  </Col>
								 </Row>
								</Col>
								<Col md="6">
								 <Row>
								  <Col md="5">
									<FormGroup>
									  <b>Country</b>
									</FormGroup>
								  </Col>
								  <Col md="7">
									<span>: {this.state.country}</span>
								  </Col>
								 </Row>
								</Col>
								<Col md="6">
								 <Row>
								  <Col md="5">
									<FormGroup>
									  <b>Currency Type</b>
									</FormGroup>
								  </Col>
								  <Col md="7">
									<span>: {this.state.currency}</span>
								  </Col>
								 </Row>
								</Col>
								<Col md="6">
								 <Row>
								  <Col md="5">
									<FormGroup>
									  <b>Language</b>
									</FormGroup>
								  </Col>
								  <Col md="7">
									<span>: {this.state.language}</span>
								  </Col>
								 </Row>
								</Col>
								<Col md="6">
								 <Row>
								  <Col md="5">
									<FormGroup>
									  <b>Institution Code</b>
									</FormGroup>
								  </Col>
								  <Col md="7">
									<span>: {this.state.inscode}</span>
								  </Col>
								 </Row>
								</Col>
								<Col md="6">
								 <Row>
								  <Col md="5">
									<FormGroup>
									  <b>Timezone</b>
									</FormGroup>
								  </Col>
								  <Col md="7">
									<span>: {this.state.timezone}</span>
								  </Col>
								 </Row>
								</Col>
							 </Row>
							 </CardBody>
							</Card>
							</Col>
							<Col md="3">
								<Card>
									<CardBody id="cen">
										<img src={this.state.url} id="logo" /><br></br><br></br>
										<div id="cen">
											<h5>{this.state.name}</h5>
											<span>{this.state.email}</span>
										</div>
									</CardBody>
								</Card>
							 </Col>
							</Row>
						</CardBody>
					</Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default InstitutionView;


// WEBPACK FOOTER //
// ./src/settings/InstitutionView/InstitutionView.js